import React from 'react';
import PropTypes from 'prop-types';
import { GlobalActions } from '../../context/actions';
import '../../styles/ProgressBar.scss';

class ProgressBar extends React.Component {
  constructor(props) {
    super(props);

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);

    this.lastX = null;

    this.max;
    this.current;
    this.viewable;
    this.next;
    this.backTo;

    this.inner;
  }

  handleMouseDown(e) {
    this.handleMouseMove(e);
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  }

  handleMouseMove(e) {
    e.preventDefault();
    let chunkNum;

    // how far around mouse on X to look for viewable chunk
    let searchRadius = 60;
    let rect = this.inner.getBoundingClientRect();
    let width = rect.right - rect.left;

    let x = e.clientX - rect.left;
    if (x <= 0) {
      chunkNum = 0;

    } else if (x >= width) {
      chunkNum = this.max - 1;

    } else {
      // translate to viewable chunk array index
      x = Math.round((x / width) * this.max);
      if (x === this.current) {
        return;
      }

      // search for the closest viewable chunk in a certain radius
      for (let i = 0; i <= searchRadius; i++) {
        if (i === 0) {
          if (this.viewable[x]) {
            chunkNum = x;
            break;
          }
          continue;
        }

        if (this.viewable[x + i]) {
          chunkNum = x + i;
          break;
        }

        if (this.viewable[x - i]) {
          chunkNum = x - i;
          break;
        }
      }
    }

    // move to chunk
    if (this.viewable[chunkNum]) {
      if (chunkNum > this.current) {
        this.next({stopAt: chunkNum, playing: false});
      }
      if (chunkNum < this.current && chunkNum !== this.max - 1) {
        this.backTo({stopAt: chunkNum, playing: false});
      }
    }
  }

  handleMouseUp(e) {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  }

  refresh() {
    this.forceUpdate();
  }

  render() {
    const { current, max, state, dispatch } = this.props;
    const node = {
      rectPrimary: document.querySelector('.mux-lpi-rect--primary'),
      buffer: document.querySelector('.mux-lpi-buffer'),
      inner: document.querySelector('.mux-lpi-inner'),
      thumb: document.querySelector('.progressThumb'),
    };
    this.inner = node.inner;

    this.max = max;
    this.current = current;
    this.viewable = (state.chunker !== undefined) ?
      state.chunker.viewable :
      null;

    this.backTo = (playing) => {
      dispatch(GlobalActions.BACK_TO_LINE, playing);
    };

    this.next = (playing) => {
      dispatch(GlobalActions.NEXT_LINE, playing);
    };

    function setTransform(ref, value) {
      if (ref !== null) {
        const { style } = ref;
        style.transform = value;
        style.WebkitTransform = value;
        style.MozTransform = value;
        style.OTransform = value;
        style.MSTransform = value;
      }
    }

    // set the progress bar body
    const setProgress = (ref, val) => {
      setTransform(ref, `scaleX(${val})`);
    }

    function setBuffer(ref, val) {
      setTransform(ref, `scaleX(${val})`);
    }

    // set the slider thumb position
    const setThumb = (thumb, value) => {
      if (thumb !== null) {
        const { style } = thumb;
        let x = 0;

        if (this !== undefined) {
          x = value * this.inner.offsetWidth;
        }
        let transform = `translateX(${x}px)`;

        style.transform = transform;
        style.WebkitTransform = transform;
        style.MozTransform = transform;
        style.OTransform = transform;
        style.MSTransform = transform;
      }
    }

    setProgress(node.rectPrimary, parseFloat(current / max, 10));
    setBuffer(node.buffer, 1);
    setThumb(node.thumb, parseFloat(current / max, 10));
    // For some weird reason the "current" chunk number overshoots for
    // the last chunk so we a a fudge here (also, max is one more than the
    // number of chunks)
    let curr = (current === max? max - 1: current);

    return (
        <div
          role="progressbar"
          className="mux-lpi"
          tabIndex={0}
          onMouseDown={this.handleMouseDown}
        >
          <div className="mux-lpi-padding" />
          <div className="mux-lpi-inner">
            <div className="progressLable" id="progressLabel">
              <div className="innerText">
                {
                  "Progress:" + curr + "/" + (max-1) + "=" + Math.round((curr / (max-1)) * 100, 2) + "%"
                }
              </div>
            </div>
            <div className="progressThumb">
              <div className="innerThumb" />
            </div>
            <div className="mux-lpi-buffer" />
            <div className="mux-lpi-rect mux-lpi-rect--primary">
              <span className="mux-lpi-rect-inner" />
            </div>
          </div>
        </div>
    );
  }
}

export default ProgressBar;
ProgressBar.propTypes = {
  current: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  state: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};
